import { Component } from "@angular/core";

@Component({
  selector: "app-replacement-claim-overview-delivered",
  templateUrl: "./replacement-claim-overview-delivered.component.html",
  styleUrls: ["./replacement-claim-overview-delivered.component.less"],
})
export class ReplacementClaimOverviewDeliveredComponent {}
